import { render } from "./CreateSupplierInvoice.vue?vue&type=template&id=2e05ef3c"
import script from "./CreateSupplierInvoice.vue?vue&type=script&lang=js"
export * from "./CreateSupplierInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__